"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectNameAndProjectDialog = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var TestIds_1 = require("../../../util/TestIds");
var SelectNameDialogComponent_1 = require("./SelectNameDialogComponent");
var SelectProjectDialogComponent_1 = require("./SelectProjectDialogComponent");
var SelectNameAndProjectDialog = /** @class */ (function (_super) {
    __extends(SelectNameAndProjectDialog, _super);
    function SelectNameAndProjectDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.projectId = '';
        _this.predictiveModelName = '';
        _this.onProjectSelected = function (projectId) {
            _this.projectId = projectId;
            _this.setState({ invalidInput: _this.isInvalidInput() });
        };
        _this.onPredictiveModelNameChange = function (name) {
            _this.predictiveModelName = name;
            _this.setState({ invalidInput: _this.isInvalidInput() });
        };
        _this.isInvalidInput = function () {
            return _this.projectId.length === 0 || _this.predictiveModelName.trim().length === 0;
        };
        _this.onDialogOk = function () {
            _this.props.onConfirmRequest(_this.projectId, _this.predictiveModelName);
        };
        _this.wrappedOnCloseRequest = function () {
            _this.props.onCloseRequest();
        };
        _this.state = { invalidInput: true };
        _this.predictiveModelName = _this.props.initialPredictiveModelName;
        return _this;
    }
    SelectNameAndProjectDialog.prototype.BuildProps = function () {
        var dialogFooterButtonsProps = {
            buttons: [
                {
                    handleClick: this.wrappedOnCloseRequest,
                    buttonType: widgets_1.ButtonType.Outline,
                    children: Localize_1.Messages.deployModelDialogCancel(),
                    testId: TestIds_1.DEPLOY_MODEL_DIALOG_CANCEL,
                },
                {
                    handleClick: this.onDialogOk,
                    buttonType: widgets_1.ButtonType.Primary,
                    disabled: this.state.invalidInput,
                    children: Localize_1.Messages.deployModelDialogConfirm(),
                    testId: TestIds_1.DEPLOY_MODEL_DIALOG_CONFIRM,
                },
            ],
            testId: TestIds_1.DEPLOY_MODEL_DIALOG_FOOTER,
        };
        var dialogProps = {
            shouldReturnFocusOnClose: false,
            zIndex: 1031,
            dialogWidth: 350,
            dialogStyle: {
                maxWidth: 500,
            },
            type: widgets_1.DialogType.NormalWithTitleBar,
            title: Localize_1.Messages.deployModelDialogTitle(),
            showCloseButton: true,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            isModal: true,
            testId: TestIds_1.DEPLOY_MODEL_DIALOG,
            onCloseRequest: this.wrappedOnCloseRequest,
            showFooter: true,
            footerContent: React.createElement(widgets_1.DialogFooterButtonsWidget, __assign({}, dialogFooterButtonsProps)),
        };
        return dialogProps;
    };
    SelectNameAndProjectDialog.prototype.render = function () {
        return (React.createElement(widgets_1.DialogWidget, __assign({}, this.BuildProps()),
            React.createElement(SelectNameDialogComponent_1.SelectNameDialogComponent, { initialPredictiveModelName: this.props.initialPredictiveModelName, onNameChanged: this.onPredictiveModelNameChange }),
            React.createElement(SelectProjectDialogComponent_1.SelectProjectDialogComponent, { onProjectSelected: this.onProjectSelected, siteName: this.props.siteName })));
    };
    return SelectNameAndProjectDialog;
}(React.Component));
exports.SelectNameAndProjectDialog = SelectNameAndProjectDialog;
//# sourceMappingURL=SelectNameAndProjectDialog.js.map